import axios from "axios";
import label from "@/lang/StaticLabels.js";
import alert from "@/lang/AlertMessages.js";
const baseUrl = "base/api/v1/";
const ordrUrl = "sale/api/v1/basic/ordr/";
// سفارش: همان جدول پیش فاکتور با typeId = 2 (بکند نوع را خودش می‌گذارد)
const orderUrl = "sale/api/v1/operation/ordr/Order";
const orderPermitUrl = "sale/api/v1/operation/ordr/OrderPermit";
const orderDraftUrl = "sale/api/v1/operation/ordr/OrderDraft";

export default {
  // BlackList Actions ------------------------------------------------------------------
  getBlackLists({ dispatch, commit }) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(baseUrl + "BlackList")
      .then((res) => {
        commit("setBlackLists", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  addBlackList({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(baseUrl + "BlackList", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editBlackList({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(baseUrl + "BlackList/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteBlackList({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(baseUrl + "BlackList", {
        data,
      })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // SaleManagerDiscountLimit Actions - سطح تخفیف مجاز کاربران ---------------------------
  getSaleManagerDiscountLimits({ dispatch, commit }) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(ordrUrl + "SaleManagerDiscountLimit")
      .then((res) => {
        commit("setSaleManagerDiscountLimits", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  addSaleManagerDiscountLimit({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(ordrUrl + "SaleManagerDiscountLimit", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editSaleManagerDiscountLimit({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(ordrUrl + "SaleManagerDiscountLimit/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteSaleManagerDiscountLimit({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(ordrUrl + "SaleManagerDiscountLimit", {
        data,
      })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // SaleManagerCredit Actions - اعتبار مسئول فروش ---------------------------
  // data: رشتهٔ کوئری فیلترها (personId، fromDate، toDate)
  getSaleManagerCredits({ dispatch, commit }, data = "") {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(ordrUrl + "SaleManagerCredit" + data)
      .then((res) => {
        commit("setSaleManagerCredits", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  addSaleManagerCredit({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(ordrUrl + "SaleManagerCredit", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editSaleManagerCredit({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(ordrUrl + "SaleManagerCredit/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteSaleManagerCredit({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(ordrUrl + "SaleManagerCredit", {
        data,
      })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // Setting Actions - تنظیمات ماژول سفارشات ----------------------------------
  getOrdrSettings({ dispatch, commit }) {
    return axios
      .get(ordrUrl + "Setting")
      .then((res) => {
        commit("setOrdrSettings", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  // data: { id, value } — مقدار همیشه رشته است (چند انتخابی با کاما، خالی = "")
  editOrdrSetting({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(ordrUrl + "Setting/" + data.id, { value: data.value })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // Order Actions - سفارش ----------------------------------------------------
  // data: رشتهٔ کوئری فیلترها (fromDate، toDate، fromCode، toCode، isCancel، isConfirm)
  getOrders({ dispatch, commit }, data = "") {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(orderUrl + "?" + data)
      .then((res) => {
        commit("setOrders", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getOrderById({ dispatch, commit }, data) {
    return axios
      .get(orderUrl + "/" + data)
      .then((res) => {
        commit("setOrderById", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
     
  getOrderCommodities({ dispatch }, id) {
    return axios
      .get(orderUrl + "/" + id)
      .then((res) => res.data.data?.orderCommodities || [])
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
        return [];
      });
  },

  // کپی سفارش: اطلاعات سفارش مبدا بدون ثبت در استور برگردانده می‌شود
  getOrderForCopy({ dispatch }, id) {
    return axios
      .get(orderUrl + "/" + id)
      .then((res) => res.data.data || null)
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
        return null;
      });
  },

  addOrder({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(orderUrl, data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: "PORDROrderList",
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editOrder({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(orderUrl + "/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: "PORDROrderList",
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteOrder({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(orderUrl, { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // انصراف (status = true) یا برگرداندن انصراف (status = false)
  // data: { ids: ["guid"], status }؛ پرامیس true/false برمی‌گرداند
  cancelOrder({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    return axios
      .put(orderUrl + "/Cancel?status=" + data.status, data.ids)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
        return res.status === 200;
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
        return false;
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getOrderMaxCode({ dispatch, commit }) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .get(orderUrl + "/MaxCode")
      .then((res) => {
        commit("setOrderMaxCode", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getOrderSearch({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .get(orderUrl + "/Get/" + data)
      .then((res) => {
        commit("setOrderById", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getOrderNavigation({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .get(orderUrl + "/Navigation?" + data)
      .then((res) => {
        commit("setOrderById", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // محاسبهٔ یک ردیف کالا بدون تغییر فرم ورود کالا (برای اعمال تخفیف دوره‌ای روی ردیف‌های ثبت‌شده)
  calculateOrderCommodity({ dispatch }, data) {
    return axios
      .post(orderUrl + "/Calculate", data)
      .then((res) => res.data.data)
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
        return null;
      });
  },

  // اعتبار مشتری: { isVisible, credit }
  getCustomerCredit({ dispatch }, customerId) {
    return axios
      .get(orderUrl + "/CustomerCredit?customerId=" + customerId)
      .then((res) => res.data.data)
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
        return null;
      });
  },

  // اعتبار مسئول فروش؛ null یعنی بدون محدودیت
  // data: رشتهٔ کوئری saleManagerId، date و در ویرایش orderId
  getOrderSaleManagerCredit({ dispatch }, data) {
    return axios
      .get(orderUrl + "/SaleManagerCredit?" + data)
      .then((res) => res.data.data)
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
        return undefined;
      });
  },

  // تخفیف دوره‌ای فعال کالاها برای مشتری در تاریخ سفارش
  // data: { customerId, date, commodityIds: [] }
  getCommodityDiscountPolicies({ dispatch }, data) {
    return axios
      .post(orderUrl + "/CommodityDiscountPolicies", data)
      .then((res) => res.data.data || [])
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
        return null;
      });
  },

  // Order Cartable Actions - کارتابل تایید سفارش ------------------------------
  getOrderCartable({ dispatch, commit }) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(orderUrl + "/Cartable")
      .then((res) => {
        commit("setOrderCartable", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  // data: { ids: [], status: true/false, description }
  orderChangeStatus({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(orderUrl + "/ChangeStatus", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // Management Cartable Actions -----------------------
  getOrderManagementCartable({ dispatch, commit }, data = "") {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(orderUrl + "/ManagementCartableList?" + data)
      .then((res) => {
        commit("setOrderManagementCartable", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  orderManagementCartable({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    const type = Number(data.type || data.cartable);
    return axios
      .put(orderUrl + "/ManagementCartable", {
        ids: data.ids,
        type,
        statusId: type === 3 ? data.statusId : null,
        description: data.description || "",
      })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // Cartable Info Actions ------------------------------
  getOrderCartablePermissions({ dispatch }) {
    return axios
      .get(orderUrl + "/Cartable/Permissions")
      .then((res) => res.data.data || {})
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
        return {};
      });
  },

  getOrderCartableCustomerInfo({ dispatch }, orderId) {
    return axios
      .get(orderUrl + "/Cartable/CustomerInfo?orderId=" + orderId)
      .then((res) => res.data.data)
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
        return null;
      });
  },

  getOrderCartableReceivableDocument({ dispatch }, data) {
    return axios
      .get(orderUrl + "/Cartable/ReceivableDocument?" + data)
      .then((res) => res.data.data)
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
        return null;
      });
  },

  getOrderCartableAccountBalance({ dispatch }, data) {
    return axios
      .get(orderUrl + "/Cartable/AccountBalance?" + data)
      .then((res) => res.data.data)
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
        return null;
      });
  },

  orderWarnings({ dispatch }, data) {
    return axios
      .post(orderUrl + "/Warnings", data)
      .then((res) => res.data.data || [])
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
        return null;
      });
  },

  orderStockCheck({ dispatch }, data) {
    return axios
      .post(orderUrl + "/StockCheck", data)
      .then((res) => res.data.data)
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
        return null;
      });
  },

  // OrderPermit Actions ----------------
  getOrderPermitCartable({ dispatch, commit }, data = "") {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(orderPermitUrl + "/Cartable?" + data)
      .then((res) => {
        commit("setOrderPermitCartable", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  addOrderPermit({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(orderPermitUrl, data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getOrderPermits({ dispatch, commit }, data = "") {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(orderPermitUrl + "?" + data)
      .then((res) => {
        commit("setOrderPermits", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  deleteOrderPermit({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(orderPermitUrl, {
        data,
      })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // OrderDraft Actions -------------
  getOrderDraftCartable({ dispatch, commit }, data = "") {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(orderDraftUrl + "/Cartable?" + data)
      .then((res) => {
        commit("setOrderDraftCartable", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  addOrderDraft({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    return axios
      .post(orderDraftUrl, data)
      .then((res) => {
        commit("setSuccess", res.data.message || alert.success.submit, {
          root: true,
        });
        return res.data.data || {};
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
        return null;
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getOrderDrafts({ dispatch, commit }, data = "") {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(orderDraftUrl + "?" + data)
      .then((res) => {
        commit("setOrderDrafts", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  deleteOrderDraft({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(orderDraftUrl, {
        data,
      })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  orderCommodityChangeComplete({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    return axios
      .put(orderUrl + "/Commodity/ChangeComplete", data)
      .then((res) => {
        commit("setSuccess", res.data.message || alert.success.submit, {
          root: true,
        });
        return true;
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
        return false;
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // Print Actions ----------------------------------
  printOrderRequest({ dispatch, commit }, { printKey, url, value }) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    return axios
      .post(orderUrl + url, value || {})
      .then((res) => {
        commit("setPrintLink", { printKey, link: res.data.data });
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getPrintOrder({ dispatch }, data) {
    return dispatch("printOrderRequest", {
      printKey: "Order",
      url: "/Print/" + data.id,
      value: { ids: data.value.ids, filterMessage: data.value.filterMessage },
    });
  },

  getPrintOrderCartable({ dispatch }, data) {
    return dispatch("printOrderRequest", {
      printKey: "OrderCartable",
      url: "/Cartable/PrintCartable/" + data.id,
      value: { filterMessage: data.value.filterMessage || "" },
    });
  },

  getPrintOrderSettlement({ dispatch }, data) {
    return dispatch("printOrderRequest", {
      printKey: "OrderSettlement",
      url: "/" + data.value.orderId + "/Settlement/PrintSettlement/" + data.id,
    });
  },

  // SettlementType Actions -----------------------------------------
  getSettlementTypes({ dispatch, commit }) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(baseUrl + "SettlementType")
      .then((res) => {
        commit("setSettlementTypes", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  addSettlementType({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(baseUrl + "SettlementType", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editSettlementType({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(baseUrl + "SettlementType/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteSettlementType({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(baseUrl + "SettlementType", {
        data,
      })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getSettlementTypeCode({ dispatch, commit }) {
      axios
        .get(baseUrl + "SettlementType/MaxCode")
        .then((res) => {
          commit("setSettlementTypeCode", res.data.data);
        })
        .catch((error) => {
          dispatch("errorGETHandler", error, { root: true });
        });
    },

  // Order Settlement Actions ---------------------------------------
  generateOrderSettlement({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    return axios
      .post(orderUrl + "/Settlement/Generate", data)
      .then((res) => res.data.data)
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
        return null;
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 500);
      });
  },

  orderSettlementVoucherPreview({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    return axios
      .post(orderUrl + "/Settlement/VoucherPreview", data)
      .then((res) => res.data.data)
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
        return null;
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 500);
      });
  },

  settleOrder({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    return axios
      .post(orderUrl + "/Settlement", data)
      .then((res) => {
        commit("setSuccess", res.data.message || alert.success.submit, {
          root: true,
        });
        return true;
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
        return false;
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getOrderSettlement({ dispatch, commit }, orderId) {
    commit("setLoadingBtn", true, { root: true });
    return axios
      .get(orderUrl + "/" + orderId + "/Settlement")
      .then((res) => res.data.data)
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
        return null;
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 500);
      });
  },

  deleteOrderSettlement({ dispatch, commit }, orderId) {
    commit("setLoadingBtn", true, { root: true });
    return axios
      .delete(orderUrl + "/" + orderId + "/Settlement")
      .then((res) => {
        commit("setSuccess", res.data.message || alert.success.submit, {
          root: true,
        });
        return true;
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
        return false;
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteOrderSettlementVoucher({ dispatch, commit }, orderId) {
    commit("setLoadingBtn", true, { root: true });
    return axios
      .delete(orderUrl + "/" + orderId + "/Settlement/Voucher")
      .then((res) => {
        commit("setSuccess", res.data.message || alert.success.submit, {
          root: true,
        });
        return true;
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
        return false;
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  sendOrderSettlementSms({ dispatch, commit }, orderId) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(orderUrl + "/" + orderId + "/Settlement/Sms")
      .then((res) => {
        commit("setSuccess", res.data.message || alert.success.submit, {
          root: true,
        });
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },
};
